import script from "./NonQFZP.vue?vue&type=script&setup=true&lang=js"
export * from "./NonQFZP.vue?vue&type=script&setup=true&lang=js"

import "./NonQFZP.vue?vue&type=style&index=0&id=bd1b281e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd1b281e"]])

export default __exports__